import * as React from "react";

type PropsHighlightedText = {
  text: string;
  selected: string | null | undefined;
  className?: string;
};

export const HighlightedText: React.FC<PropsHighlightedText> = (props) => {
  const { text, selected, className } = props;
  let start = -1;
  if (selected) start = text.toLowerCase().indexOf(selected.toLowerCase());
  if (start < 0 || !selected) return <span className={className}>{text}</span>;
  const stop = start + selected.length;
  return (
    <span className={className}>
      {text.slice(0, start)}
      {start >= 0 && (
        <span style={{ background: "yellow" }}>{text.slice(start, stop)}</span>
      )}
      {text.slice(stop)}
    </span>
  );
};
